import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'filter'})
export class FilterPipe implements PipeTransform {
  /**
   * Transform
   *
   * @param {any[]} mainArr
   * @param {string} searchText
   * @param {string} property
   * @returns {any}
   */
  transform(mainArr: any[], searchText: string, property: string): any {
    if (!searchText) {
      return mainArr;
    }
    return mainArr.filter((item) => item[property].toLowerCase().includes(searchText.toLowerCase()));
  }
}
